@if (loading$ | async) {
  <ppl-loading-overlay></ppl-loading-overlay>
}
<input
  #phone
  pplInput
  type="tel"
  [disabled]="disabled || (loading$ | async)"
  [value]="(loading$ | async) || !value ? '' : value.number"
  (countrychange)="onCountryChange()"
  (input)="onInputChange($event)" />
